module.exports = __webpack_public_path__ + "images/emoji/stew.d5d15a92682581cdcebe.png";